import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.24.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.24.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/regenerator/index.js";
import { AnimatePresence, motion } from 'framer-motion';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FAQs, GUEST_BENEFITS } from 'lib/constants/landing';
import { LISTING_TYPES_LABELS } from 'lib/constants/listings';
import { getPrivateProfile } from 'lib/db';
import { useAuthUser } from 'lib/hooks/auth';
import { middleware } from 'lib/middleware/page';
import Router, { getPath } from 'lib/router';
import CTAButton from 'components/CTAButton';
import CTALink from 'components/CTALink';
import Confetti from 'components/Confetti';
import FaqSection from 'components/Faq/FaqSection';
import Layout from 'components/Layout';
import LazyImage from 'components/LazyImage';
import CTANav from 'components/Navbars/CTANav';
import { useIsMobile } from 'components/Responsive';
import { SocialProof } from 'components/SocialProof';
import { prompts, toasts } from 'components/alert';
import { requireLogin } from 'components/form/LoginPrompt';
import { FeaturesComparison } from 'components/landing/FeaturesComparison';
import { ReferHost } from 'components/landing/ReferHost';
import { showReferralModal } from 'components/landing/ReferralModal';
import { WhatIsWanderglade } from 'components/landing/WhatIsWanderglade';
import MetaGraph from 'components/social/MetaGraph';
var HomePage = function HomePage(_ref) {
  var isLister = _ref.isLister;
  var isMobile = useIsMobile();
  var currentUser = useAuthUser();
  var _useState = useState(0),
    currentWordIndex = _useState[0],
    setCurrentWordIndex = _useState[1];
  var places = LISTING_TYPES_LABELS;

  // Get ref, show_ref, and is_new from query params
  var router = useRouter();
  var query = router.query;
  var referrer = query.ref;
  var showReferral = query.show_ref;
  var isNewListing = query.is_new;
  var listingId = query.listing_id;
  var isWaitlisted = query.waitlisted;
  var isAirbnbNewListing = query.is_airbnb_new;
  var isVRBONewListing = query.is_vrbo_new;

  // If there's a referrer, we redirect to the host page with the referrer query param
  useEffect(function () {
    if (referrer) {
      Router.push("/host?ref=".concat(referrer));
    }
  }, [referrer]);
  useEffect(function () {
    var interval = setInterval(function () {
      setCurrentWordIndex(function (prevIndex) {
        return (prevIndex + 1) % places.length;
      });
    }, 2000);
    return function () {
      return clearInterval(interval);
    };
  }, [places]);
  var _useState2 = useState([1, 2, 3, 4, 5]),
    randomOrder = _useState2[0],
    setRandomOrder = _useState2[1];
  useEffect(function () {
    // Shuffle the order of images on component mount
    var shuffled = _toConsumableArray(randomOrder);
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref2 = [shuffled[j], shuffled[i]];
      shuffled[i] = _ref2[0];
      shuffled[j] = _ref2[1];
    }
    setRandomOrder(shuffled);
  }, []);
  var variants = {
    enter: {
      y: '100%',
      opacity: 0
    },
    center: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: '-100%',
      opacity: 0
    }
  };
  var title = 'Wanderglade | Book Unique Cabins & Plan Nature Getaways';
  var description = 'Discover unique cabin getaways with Wanderglade. Plan your perfect nature escape with curated stays and a trip planner. Launching soon in Upstate NY!';
  useEffect(function () {
    if (isNewListing) {
      prompts.confirm(__jsx("div", {
        className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-w-full sm:tw-w-auto"
      }, __jsx("h3", {
        className: "tw-text-3xl tw-font-bold tw-text-center tw-text-dark-ebony"
      }, "Application Submitted! \uD83C\uDF89\uD83D\uDCDD"), __jsx("p", {
        className: "tw-text-center tw-mt-5 tw-font-sans tw-text-sm tw-text-dark-ebony"
      }, "Congratulations on submitting your Wanderglade host application! Our team will review it to ensure it meets our standards and guidelines."), __jsx("p", {
        className: "tw-text-center tw-font-sans tw-text-sm tw-my-5 tw-text-dark-ebony"
      }, "If your application is approved, you will receive an email with further instructions on how to get started."), __jsx("p", {
        className: "tw-text-center tw-font-sans tw-text-sm tw-text-dark-ebony"
      }, "Thank you for choosing Wanderglade. We look forward to reviewing your application!")), {
        confirmMsg: 'Upload Proof of Residency',
        cancelMsg: 'Upload later',
        onClickConfirm: function onClickConfirm() {
          return Router.push("/verify?listing=".concat(listingId));
        }
      });
    }
    if (isAirbnbNewListing || isVRBONewListing) {
      prompts.alert(__jsx("div", {
        className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-w-full sm:tw-w-auto"
      }, __jsx("h3", {
        className: "tw-text-3xl tw-font-bold tw-text-center tw-text-dark-ebony"
      }, "Listing Created! \uD83C\uDF89\uD83D\uDCDD"), __jsx("p", {
        className: "tw-text-center tw-mt-5 tw-font-sans tw-text-sm tw-text-dark-ebony"
      }, "Congratulations on importing your ", isAirbnbNewListing ? 'Airbnb' : 'VRBO', " listing to Wanderglade!"), __jsx("p", {
        className: "tw-text-center tw-my-5 tw-font-sans tw-text-sm tw-text-dark-ebony"
      }, "We're excited to have you join our community. Your property is now set up and ready to welcome new guests."), __jsx("p", {
        className: "tw-text-center tw-font-sans tw-text-sm tw-text-dark-ebony"
      }, "We look forward to supporting you as you host with us.")), {
        cancelMsg: 'Got it!'
      });
    }
  }, [isNewListing, isAirbnbNewListing, isVRBONewListing]);
  useEffect(function () {
    if (showReferral && currentUser !== null && currentUser !== void 0 && currentUser.uid) {
      showReferralModal({
        userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid,
        clearReferralQueryParam: true,
        isMobile: isMobile
      });
    }
  }, [showReferral, currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid, isMobile]);
  useEffect(function () {
    if (isWaitlisted) {
      if (currentUser !== null && currentUser !== void 0 && currentUser.uid) {
        showReferralModal({
          userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid,
          clearReferralQueryParam: true,
          title: " Your're on the waitlist 🎉",
          deleteUrlParam: 'waitlisted',
          isMobile: isMobile
        });
      } else toasts.success('You are on the waitlist 🎉');
    }
  }, [isWaitlisted, currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid, isMobile]);
  return __jsx(React.Fragment, null, (isNewListing || isAirbnbNewListing) && __jsx(Confetti, {
    fullPage: true
  }), __jsx(Layout, {
    navbar: __jsx(CTANav, {
      cta: "Become a Host",
      ctaLink: "/host"
    })
  }, __jsx(MetaGraph, {
    title: title,
    description: description
  }), __jsx("section", {
    className: "hero is-medium is-bold"
  }, __jsx("div", {
    className: "hero-body columns is-multiline section m-0 has-text-centered",
    style: {
      position: 'relative'
    }
  }, __jsx("video", {
    id: "video",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      filter: 'brightness(0.4)'
    },
    autoPlay: true,
    muted: true,
    playsInline: true,
    loop: true,
    preload: "auto",
    poster: "/static/landing/hero-video-poster.png"
  }, __jsx("source", {
    // src="https://videos.pexels.com/video-files/9243602/9243602-uhd_4096_2160_25fps.mp4"
    src: "/static/landing/hero-video-og.mp4",
    type: "video/mp4"
  }), "Your browser does not support the video tag."), __jsx("div", {
    className: "column is-full flex flex-col justify-center container tw-items-center",
    style: {
      color: '#F7E7CE'
    }
  }, __jsx("div", {
    className: "font-secondary box py-2 px-4 tw-bg-sage",
    style: {
      backgroundColor: '#BFBDA3',
      borderRadius: '20px',
      maxWidth: 'max-content',
      color: '#565940'
    }
  }, __jsx("p", {
    className: "tw-text-sm tw-px-4"
  }, ' ', "Wanderglade will be launching in ", __jsx("b", null, "Upstate New York"), " in Fall", ' ')), __jsx("h1", {
    className: "tw-text-4xl tw-font-bold sm:tw-text-5xl tw-text-champagne"
  }, ' ', "Disconnect to Reconnect", ' '), __jsx("p", {
    className: "tw-pt-8 sm:tw-pt-6 tw-font-sans-serif tw-md tw-text-xl tw-text-champagne tw-px-4 tw-text-bold"
  }, ' ', "Explore a curated selection of unique gataways and plan your entire trip on one platform - Wanderglade makes it easy to find and book your perfect escape in nature.", ' '), __jsx(SocialProof, {
    messageFor: "wanderers",
    textClassName: "!tw-text-champagne"
  }), __jsx(CTAButton, {
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fromPath, authUser, privateProfile;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fromPath = '/?waitlisted=true';
            _context.next = 3;
            return requireLogin(fromPath);
          case 3:
            authUser = _context.sent;
            if (authUser) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            _context.next = 8;
            return getPrivateProfile(authUser.uid);
          case 8:
            privateProfile = _context.sent;
            if (!privateProfile.onboarded) {
              Router.push(getPath('onboarding', {
                from: fromPath
              }));
            }
            showReferralModal({
              userId: authUser.uid,
              clearReferralQueryParam: true,
              isMobile: isMobile,
              title: 'You are already on the waitlist 🎉'
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    className: "tw-mt-6"
  }, "Join the Waitlist")))), __jsx("section", {
    className: "flex flex-col items-center justify-center",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, __jsx("img", {
    src: "static/hosting/cover-2.png",
    style: {
      position: 'absolute',
      top: 0,
      objectFit: 'cover',
      minHeight: '100%',
      minWidth: '100%',
      opacity: '20%',
      maskImage: 'lineargradient-(to right, #F2E0C9 0%, rgba(242, 224, 201, 0.5) 60%, rgba(242, 224, 201, 0) 100%)'
    },
    alt: "Cover"
  }), __jsx(WhatIsWanderglade, null)), __jsx(FeaturesComparison, {
    features: GUEST_BENEFITS,
    title: "Serenity Made Simple",
    description: "At Wanderglade, we believe in making your escape to nature as seamless as possible."
  }), __jsx("section", {
    className: "hero"
  }, __jsx("div", {
    className: "hero-body columns section m-0 tw-bg-ebony"
  }, __jsx("div", {
    className: "column flex flex-col justify-center container tw-text-champagne"
  }, __jsx("h1", {
    className: "is-size-1 has-text-weight-bold "
  }, "Earn Money"), __jsx("h2", {
    className: "is-size-".concat(isMobile ? '4' : '2', " has-text-weight-bold")
  }, "renting out your", ' ', __jsx(AnimatePresence, {
    initial: false
  }, __jsx(motion.span, {
    key: places[currentWordIndex],
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    transition: {
      y: {
        type: 'spring',
        stiffness: 300,
        damping: 30
      },
      opacity: {
        duration: 0.3
      }
    },
    style: {
      position: 'absolute',
      display: 'inline-block',
      color: '#E07A5F',
      marginLeft: 10
    },
    className: "has-text-weight-bold"
  }, places[currentWordIndex]))), __jsx("p", {
    className: "font-sans-serif my-4 tw-text-champagne"
  }, "List. Relax. Earn: showcase your space, benefit from low fees, and trust in verified guests."), !isLister && __jsx(CTALink, {
    href: "/host/create",
    loginRequired: true
  }, "Apply for Free")), __jsx("div", {
    className: "column container hero "
  }, __jsx(LazyImage, {
    src: "static/landing/listing-pin-map.svg",
    width: 860,
    height: 530
  })))), __jsx("section", {
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, __jsx("img", {
    src: "static/hosting/cover-3.png",
    style: {
      zIndex: 1,
      position: 'absolute',
      bottom: 0,
      objectPosition: 'left',
      objectFit: 'cover',
      minHeight: '80%',
      minWidth: '100%',
      opacity: '20%',
      pointerEvents: 'none'
    },
    alt: "Cover"
  }), __jsx(FaqSection, {
    items: FAQs,
    openFirst: true
  })), __jsx(ReferHost, null)));
};
export var getServerSideProps = middleware( /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ctx) {
    var _ctx$auth;
    var userId, isLister;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          userId = (_ctx$auth = ctx.auth) === null || _ctx$auth === void 0 ? void 0 : _ctx$auth.uid;
          if (!userId) {
            _context2.next = 5;
            break;
          }
          _context2.next = 4;
          return getPrivateProfile(userId);
        case 4:
          isLister = _context2.sent.isLister;
        case 5:
          return _context2.abrupt("return", {
            isLister: isLister
          });
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x) {
    return _ref4.apply(this, arguments);
  };
}());
export default HomePage;